module.exports = "//static.hsappstatic.net/LoginUI/static-1.13356/img/apple-logo.png"